<template>
  <div
    v-show="showCalendarButtons"
    class="button-container"
    :class="showCalendarButtons && 'open'"
    role="listbox"
    :style="primaryTextColor"
  >
    <AddToCalendar
      v-for="(type, idx) in calendarOptions"
      :id="`calendar-option-${idx}`"
      :key="idx"
      :ref="`calendar-option-${idx}`"
      :calendar-type="type.value"
      :event-data="eventData"
      :color-overrides="colorOverrides"
      role="option"
      tabindex="0"
      class="calendar-option"
      @keydown.down.stop.prevent="handleListboxKeydown(idx + 1)"
      @keydown.up.stop.prevent="handleListboxKeydown(idx - 1)"
    />
    <FormButton
      ref="calendar-option-3"
      variant="default"
      mode="default"
      class="back-calendar-button"
      tabindex="0"
      :full-width="true"
      :color-overrides="colorOverrides"
      @click.stop.prevent="handleBackButtonClick"
      @keydown.up.stop.prevent="handleListboxKeydown(calendarOptions.length - 1)"
      @keydown.down.stop.prevent="handleListboxKeydown(0)"
      @keydown.enter.exact.prevent.stop="handleBackButtonClick"
      @keydown.space.exact.prevent.stop="handleBackButtonClick"
      @keydown.tab.exact.prevent.stop="handleBlur"
      @keydown.esc.exact.prevent.stop="handleBlur"
    >
      <img
        v-if="useCloseIcon"
        src="../../../../../assets/close-icon.svg"
        :alt="$t('search.closeOptions')"
      />
      <Icon
        v-else-if="useNewCloseIcon"
        name="lucide:x"
        size="14"
      />
      <span v-else>{{ $t('events.back') }}</span>
    </FormButton>
  </div>
</template>

<script>
import FormButton from '../../../../global/Forms/FormButton';
import AddToCalendar from '../shared/AddToCalendar';
import { useThemedButtons } from '@/composables/useThemedButtons';

export default {
  name: 'EventListButtons',
  components: {
    FormButton,
    AddToCalendar,
  },
  props: {
    handleBackButtonClick: {
      type: Function,
      default: () => {},
    },
    handleBlur: {
      type: Function,
      default: () => {},
    },
    colorOverrides: {
      type: Object,
      default: null,
    },
    eventData: {
      type: Object,
      default: null,
    },
    showCalendarButtons: Boolean,
    useCloseIcon: Boolean,
    useNewCloseIcon: Boolean,
  },
  data() {
    return {
      calendarOptions: [
        { idx: 0, name: 'Google', value: 'google' },
        { idx: 1, name: 'Outlook', value: 'outlook' },
        { idx: 2, name: 'iCal', value: 'iCal' },
      ],
    };
  },

  computed: {
    primaryTextColor() {
      const { themedButtons } = useThemedButtons();

      return { '--primary-button-text': themedButtons['--secondary-button-text'] };
    },
  },
  methods: {
    handleListboxKeydown(idx) {
      if (idx === -1 || idx === undefined) return;
      if (idx > this.calendarOptions.length - 1) {
        this.$refs['calendar-option-3'].$el.focus();
        return;
      }
      this.$refs[`calendar-option-${idx}`][0].$el.focus();
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../../../global/scss/mixins/flex_mixin';
@use '../../../../global/scss/mixins/breakpoints';

.button-container {
  @include flex_mixin.flex-row;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;

  @media (min-width: breakpoints.$md) {
    @include flex_mixin.flex-column;
    justify-content: stretch;
  }

  &.open {
    @include flex_mixin.flex-column;
    justify-content: stretch;
  }

  & p.button-text {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;

    text-align: center;
    letter-spacing: 0.4px;

    color: #333333;
  }
  .back-calendar-button:hover {
    color: var(--primary-button-text);
  }
  .calendar-option,
  .back-calendar-button {
    &:focus-visible {
      outline: 2px solid #000fff;
    }
  }
  .back-calendar-button {
    .iconify {
      color: var(--primary-button-text);
    }
  }
  .calendar-option {
    &:hover {
      color: var(--primary-button-text);
    }
  }
}

.calendar-buttons {
  @include flex_mixin.flex-column;
}
</style>
